import { motion } from "framer-motion";
import { useLanguage } from "@/lib/i18n";
import "./LocalReach.css";

const AREAS = ["Surat", "Navsari", "Bharuch", "Ankleshwar", "Bardoli", "Valsad"];

/** Local marketing band — Surat & nearby Gujarat areas, open to members worldwide. */
export default function LocalReach() {
  const { t } = useLanguage();
  return (
    <section className="local-reach" data-testid="local-reach-section">
      <motion.div
        className="local-reach-inner"
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.55, ease: "easeOut" }}
      >
        <p className="local-reach-eyebrow">{t("Rooted in Surat")}</p>
        <h2 className="local-reach-title" data-testid="local-reach-title">
          {t("Serving families across South Gujarat & beyond")}
        </h2>
        <p className="local-reach-text" data-testid="local-reach-text">
          {t("Families in Surat and nearby towns trust Suffa Matrimony to guide rishtas for Nikah with care, dignity and personal admin oversight — and members join us from around the world. Browse profiles free and register in minutes.")}
        </p>
        <div className="local-reach-areas" data-testid="local-reach-areas">
          {AREAS.map((a) => (
            <span className="local-reach-chip" key={a}>{a}</span>
          ))}
          <span className="local-reach-chip local-reach-chip-world">{t("Worldwide members")}</span>
        </div>
        <a href="/register" className="btn btn-solid btn-lg local-reach-cta" data-testid="local-reach-register-btn">
          {t("Register Profile")}
        </a>
      </motion.div>
    </section>
  );
}
